<template>
  <div
    class="w-full shadow rounded overflow-hidden flex flex-col"
    :class="[tileView === 'grid' ? '' : 'md:flex-row']"
  >
    <div
      class="relative w-full h-40"
      :class="[tileView === 'grid' ? '' : 'md:w-1/4 md:h-auto']"
    >
      <div class="absolute w-full h-full bg-purple"></div>
      <div
        class="
          absolute
          w-full
          h-full
          flex
          items-center
          justify-center
          text-white
          uppercase
          font-extrabold
        "
      >
        <div>{{ title }}</div>
      </div>
      <div class="absolute w-full h-full">
        <img
          v-if="cover"
          :src="cover"
          alt=""
          class="w-full h-full object-cover"
        />
      </div>
    </div>

    <div
      class="p-5 space-y-5 bg-white w-full"
      :class="[tileView === 'grid' ? '' : 'md:w-3/4']"
    >
      <div class="flex flex-col space-y-2">
        <div class="font-bold truncate">{{ title }}</div>
        <div
          class="text-sm text-grey-500 overflow-hidden h-20"
          :class="[tileView === 'grid' ? '' : 'md:h-10']"
        >
          {{ description.substring(0, 100) }}
          {{ description.length >= 100 ? '...' : '' }}
        </div>
      </div>
      <div
        class="flex flex-col space-y-4"
        :class="[
          tileView === 'grid'
            ? ''
            : 'md:flex-row md:justify-between md:space-y-0',
        ]"
      >
        <div class="w-full" :class="[tileView === 'grid' ? '' : 'md:w-auto']">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tile',
  props: {
    cover: {},
    tileView: {
      default: 'list',
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    instructor: {
      type: Object,
      default: () => {
        return {
          name: null,
          profile_image: null,
        };
      },
    },
  },
};
</script>
